import { FieldValues, FormState } from "react-hook-form";

export const isFormSubmitForbidden = <TFieldValues extends FieldValues>(
  formState: FormState<TFieldValues>
): boolean => {
  const { isValid, dirtyFields, disabled } = formState;
  const noChanges = Object.entries(dirtyFields).length === 0;
  return !isValid || noChanges || disabled;
};
